const topLink = (() => {

  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {


    // let linkWrap = document.querySelectorAll('.sec-link');

    // if (linkWrap.length > 0) {
    //   linkWrap.forEach((linkWrap) => {
    //     let bgImg = linkWrap.querySelectorAll('.js-bgImg'); // セクション内の.js-bgImg要素を取得
    //     let TxtWrap = linkWrap.querySelectorAll('.txt-wrap'); 

    //     gsap.set(TxtWrap, {
    //       opacity: 0,
    //     });
    
    //     gsap.to(bgImg, {
    //       clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    //       duration: 0.8,
    //       ease: "sine.inOut",
    //       scrollTrigger: {
    //         trigger: linkWrap,
    //         start: "0% 50%",
    //         once: true, // アニメーションを1回だけ再生する
    //         // markers: true,
    //       },
    //       onComplete: function() {
    //         gsap.to(TxtWrap, {
    //           opacity: 1,
    //           duration: 0.8,
    //         },);
    //       },
    //     });
    //   });
    // }
        

    const linkBg = document.querySelectorAll('.js-linkBg');
    const linkBg3 = document.querySelectorAll('.js-linkBg3');
    const linkTxt = document.querySelectorAll('.js-linkTxt');
    const btnMore = document.querySelectorAll('.js-btnMore');

    gsap.set(linkTxt,{
      opacity: 0,
    });

    linkBg.forEach((linkBg) => {
      ScrollTrigger.create({
        trigger: linkBg,
        start: '30% 90%',
        // markers: true,
        onEnter: () => {
          // linkBg.classList.add('act');
          gsap.to(linkBg, {
            duration: 1.3,
            maskSize: '100%',
            ease:"expo.out",
          });          
        },
      });
    });

    linkBg3.forEach((linkBg3) => {
    ScrollTrigger.create({
      trigger: linkBg3,
      start: '30% 90%',
      // markers: true,
      onEnter: () => {
        gsap.to(linkBg3, {
          maskSize: '100%',
          ease: "expo.out",
          duration: 2,
        });
      },
    });
  });

    linkTxt.forEach((linkTxt) => {
      ScrollTrigger.create({
        trigger: linkTxt,
        start: '0% 45%',
        // markers: true,
        onEnter: () => {
          gsap.to(linkTxt, {
            duration: 1,
            opacity:1,
            ease:"expo.out",
          });
        },
      });
    });
    btnMore.forEach((btnMore) => {
      ScrollTrigger.create({
        trigger: btnMore,
        start: '0% 80%',
        // markers: true,
        onEnter: () => {
          btnMore.classList.add('act'); 
        },
      });
    });



    const locationswiper = new Swiper(".location-swiper", {
      loop: true, // ループ有効
      slidesPerView: 2,
      speed: 6000, // ループの時間
      allowTouchMove: false, // スワイプ無効
      autoplay: {
        delay: 0, // 途切れなくループ
      },
      spaceBetween: 25,
      freeMode: {
        enabled: true,
        momentum: false,
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
        },
      },
    });


  }
})();
export default topLink;